const EmailStatusCodes = {
  LOGIN: "login",
  CONFIRM_ACCOUNT: "confirmAccount",
  VERIFY_ACCOUNT: "verifyAccount"
} as const;

export default EmailStatusCodes;
